import { graphql } from "react-relay";

export const eventSummaryColorCategoryFragments = {
  user: graphql`
    fragment EventSummaryColorCategory_user on User {
      id

      webAppFlagsErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Flags {
          flags
        }
      }
    }
  `,
  org: graphql`
    fragment EventSummaryColorCategory_org on Org {
      shadowCalendarSettingsErrorable {
        __typename
        ... on ShadowCalendarSettings {
          shadowCalendarId
        }
      }
      id
      experiments
      eventColoringSettingsErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on EventColoringSettings {
          eventCategoryColorings {
            googleColorKey
            eventCategory
            active
            isUserSet
          }
        }
      }
    }
  `,
  event: graphql`
    fragment EventSummaryColorCategory_event on Event {
      title
      isClockwiseEvent
      transparency
      isAllDay
      eventKey {
        id
        externalEventId
        orgId
      }
      annotatedEvent {
        userTags {
          tag
          states {
            value
            subjectType
            subjectValue
            lastModified
            active
          }
        }
        orgTags {
          tag
          state {
            value
            subjectType
            subjectValue
            lastModified
            active
          }
        }
      }
    }
  `,
};
